import { FallbackLng } from "i18next";

export const LANGUAGE_FALLBACKS: Record<string, string[]> = {
  //en is default fallback for all locales
  "en-GB": ["en-US"], // US English
  "es-MX": ["es-ES", "en-US"], // Mexican Spanish
  "es-ES": ["es-MX", "en-US"], // Spanish Spanish
  "fr-CA": ["fr-FR", "en-US"], // Canadian French
  "fr-FR": ["fr-CA", "en-US"], // French French
  "zh-CN": ["zh-HK", "zh-TW", "en-US"],
  "zh-TW": ["zh-HK", "zh-CN", "en-US"],
  "zh-HK": ["zh-TW", "zh-CN", "en-US"],
  "ca-ES": ["es-ES", "es-MX", "en-US"], // Catalan
  "de-DE": ["en-US"], // German
  default: ["en-US"],
};

export const ALL_LANGUAGES = Object.keys({
  "ca-ES": "Català",
  "en-US": "English",
  "en-GB": "English (UK)",
  "es-MX": "Español (Latinoamerica)",
  "es-ES": "Español (España)",
  "de-DE": "Deutcsh",
  "fr-FR": "Français",
  "fr-CA": "Français (Canada)",
  "hi-IN": "हिंदी",
  "id-ID": "Bahasa Indonesia",
  "fil-PH": "Filipino",
  "pl-PL": "Polski",
  "pt-BR": "Português (Brasil)",
  "pt-PT": "Português (Portugal)",
  "tr-TR": "Türkçe",
  "th-TH": "ไทย",
  "ru-RU": "Русский",
  "uk-UA": "Українська",
  "ar-AR": "‏العربية",
  "ko-KR": "한국어",
  "zh-CN": "中文(简体)",
  "ja-JP": "日本語",
  "vi-VN": "Tiếng Việt",
});

export const BUILD_TYPE_NAMESPACE_MAP: Record<string, string> = {
  mobile: "mobile_web",
  www: "website2.website",
  default: "website2.website",
};

export const LANGUAGE_OVERWRITE_MAP: Record<string, string> = {
  "en-US": "en",
  "ar-AR": "ar-SA", // Arabic
};
